import { z } from "zod";

/**
 * One bundle component as accepted by the API: a base SKU and how many of it the
 * bundle consumes. Number inputs yield strings, so `multiplicity` is coerced then
 * validated as a positive integer. Shared by the unified Create modal and the
 * edit-bundle modal (see `create-sku-bundle-schema.ts`).
 */
export const bundleComponentSchema = z.object({
  base_sino_sku: z.string().min(1, "Required").max(64, "Max 64 characters"),
  multiplicity: z.coerce
    .number({ error: "Required" })
    .int("Must be a whole number")
    .min(1, "Must be at least 1"),
});
